import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getEventCheckIn,
  getEventDetail,
  getEventList,
} from "store/services/dataManagement/eventlisting";

export const GetEventList = createAsyncThunk(
  "event/get",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getEventList(payload);
      if (res.status === 1) return fulfillWithValue(res);
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const GetEventDetailAction = createAsyncThunk(
  "event/detail",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getEventDetail(payload);
      if (res.status === 1) return fulfillWithValue(res);
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const GetEventCheckInAction = createAsyncThunk(
  "event/checkin",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getEventCheckIn(payload);
      if (res.status === 1) return fulfillWithValue(res);
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);